import {Spin, TabsProps} from "antd";
import {HistoryExamine, Tabs} from "components/common";
import React, {Suspense, useEffect, useState} from "react";
import Received from "./Received/Received";
import "./Refractive.scss";
import {tabKeys} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setActiveKey, setSiderKey} from "redux/reducer/common";
import ReportOrthorK from "./ReportOrthorK/ReportOrthorK";

const Refractive: React.FC = () => {
  document.title = "Khúc xạ";
  const id = useAppSelector(e => e.pending?.id);
  const dispatch = useAppDispatch();
  const InforDetails = React.lazy(() => import("./InforDetails/InforDetails"));
  const activeTab = useAppSelector(state => state.common.activeTab);
  const itemsInit: TabsProps["items"] = [
    {
      key: tabKeys.REFRACTION.REFRACTION_LIST,
      label: "Danh sách bệnh nhân",
      children: <Received />,
    },
    {
      key: tabKeys.REFRACTION.REFRACTION_INFO,
      label: "Chi tiết thông tin",
      children: (
        <Suspense fallback={<Spin className="spin" />}>
          <InforDetails />
        </Suspense>
      ),
    },
    {
      key: tabKeys.REFRACTION.HISTORY_REFRACTION,
      label: "Lịch sử khám bệnh",
      children: <HistoryExamine tabName={tabKeys.REFRACTION.REFRACTION_LIST} />,
    },
    {
      key: tabKeys.REFRACTION.REPORT_ORTHOR_K,
      label: "Theo dõi BN Ortho K",
      children: <ReportOrthorK />,
    },
  ];
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  useEffect(() => {
    itemsInit[1].disabled = id == null;
    itemsInit[2].disabled = id == null;
    setItems([...itemsInit]);
  }, [id]);

  useEffect(() => {
    dispatch(setActiveKey(tabKeys.REFRACTION.REFRACTION_LIST));
    dispatch(setSiderKey("khucXa"));
  }, []);
  return (
    <div className="refractive page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default Refractive;
